import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { FeatureFlagV2QueryResponse, FeatureFlagV2QueryParams, FeatureFlagV2404 } from "../types/FeatureFlagV2";

export const featureFlagV2QueryKey = (params: FeatureFlagV2QueryParams) =>     [{url:`/api/v2/auth/check/feature_flag`},...(params ? [params] : [])] as const;
      export function featureFlagV2QueryOptions <TData = FeatureFlagV2QueryResponse, TError = FeatureFlagV2404>(params: FeatureFlagV2QueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = featureFlagV2QueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/v2/auth/check/feature_flag`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получить значение флага по его названию из неймспейса монолита
 * @link /api/v2/auth/check/feature_flag
 */

export function useFeatureFlagV2 <TData = FeatureFlagV2QueryResponse, TError = FeatureFlagV2404>(params: FeatureFlagV2QueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? featureFlagV2QueryKey(params);

  const query = useQuery<TData, TError>({
    ...featureFlagV2QueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
